import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    Grid,
    Link,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, {useContext, useState, useEffect} from 'react';

import {AddBoxOutlined, Block, Delete, Edit} from '@mui/icons-material'
import HostViewContext from '../../../Context/HostViewContext';
import { API, graphqlOperation } from 'aws-amplify';
import { deleteShow } from '../customQueries/customQueries';
import { getRecurringShow } from '../../../graphql/queries';
import moment from 'moment';

// Milad: There isn't a great way that I've found yet which lets you know which env you are on the react side without setting up continuous development
const privateShowBaseURL = `${window.location.origin}/guest/private`;

const useStyles = makeStyles(theme => ({
    showInfoContainer: {
    },
    title: {
        display: "flex",
        justifyContent: 'center'
    },
    gridItem: {
        marginBottom: '3%'
    },
    bold: {
        fontWeight: 600
    },
    arrayGrid: {
        display: "flex",
        flexDirection: "column"
    }
}))

function DialogShowAdminInfo(){
    const classes = useStyles();
    const hostViewState = useContext(HostViewContext);
    const shows = [...hostViewState.pastShows, ...hostViewState.shows];
    const show = shows.find(show => show.id === hostViewState.selectedRow.id);
    const privateShow = show?.privateShowID ? hostViewState.privateShows.find(privateShow => privateShow.id === show.privateShowID): null;
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [showOrders, setShowOrders] = useState(false);
    const [showShow, setShowShow] = useState(true);
    const [showTickets, setShowTickets] = useState(false);
    const [showReviews, setShowReviews] = useState(false);
    const [recurringShows, setRecurringShows] = useState([]);

    useEffect(() => {
        if (show.recurringShowID) {
            ( async () => {
                try {
                    const recurringShowsResponse = await API.graphql(graphqlOperation(getRecurringShow, {id: show.recurringShowID}))
                    const recurringShows = recurringShowsResponse.data.getRecurringShow.shows.items
                    setRecurringShows(recurringShows.map(show => ({show: show, checked: false,
                    displayTime: (() => {
                            let tzValue = hostViewState.timeZoneValue?.value || "America/Los_Angeles";
                            let momentDate = moment.utc(show.showtime);
                            let displayTime = momentDate.tz(tzValue).format("MMM ddd Do YYYY hh:mm a");
                            return displayTime;
                        })()
                    })));
                } catch(e) {
                    console.log("error getting recurring shows:", e)
                }
            })()
        }
    }, [])

    function handleOnClose(){
        hostViewState.dispatch({type: 'shouldShowMoreShowInfo', shouldShowMoreShowInfo: false})
    }
    
    async function handleDelete() {
        setShowConfirmationDialog(false);
        const input = { id: show.id };
        const deletedShow = await API.graphql(graphqlOperation(deleteShow, { input }));

        handleOnClose();
    }

    async function handleDeleteRecurring() {
        setShowConfirmationDialog(false);
        for (const show of recurringShows) {
            if (show.checked && show.show.status === "OPEN") {
                const input = { id: show.show.id };
                const deletedShow = await API.graphql(graphqlOperation(deleteShow, { input }));
            }
        }

        handleOnClose();
    }

    async function handleCancel() {
        setShowConfirmationDialog(false);
        
        const postData = {
            body: {
                id: show.id,
                showtime: show.showtime,
                host: {
                    hostName: show.host.hostName,
                    slackName: show.host.slackName,
                },
                experience: {
                    shortName: show.experience.shortName
                },
                guestCalendarEventId: show.guestCalendarEventId,
                hostCalendarEventId: show.hostCalendarEventId,
                orders: show.orders,
                tickets: show.tickets
            }
        };
        
        try {
            const showResponse = await API.post('alplatformapi', '/cancel', postData);
            handleOnClose();
        } catch (error) {
            console.log("error: ", error.response)
        }
    }

    async function handleEdit() {
        hostViewState.dispatch({type: 'isShowEditMode', isShowEditMode: true})
        hostViewState.dispatch({type: 'shouldShowShowsCreateEdit', shouldShowShowsCreateEdit: true})
    }

    function handleRecurringChange(index, event) {
        const recurringShowsCopy = [...recurringShows];
        recurringShowsCopy[index].checked = !recurringShowsCopy[index].checked;
        setRecurringShows(recurringShowsCopy);
    }
    
    function handleNoneClicked(){
        const recurringShowsCopy = recurringShows.map(show => ({...show, ...{checked: false}}));
        setRecurringShows(recurringShowsCopy);
    }
    
    function handleAllClicked(){
        const recurringShowsCopy = recurringShows.map(show => ({...show, ...{checked: true}}));
        setRecurringShows(recurringShowsCopy);
    }
    return <>
        {show && <>
            <Dialog open={hostViewState.shouldShowMoreShowInfo && show} onClose={handleOnClose} fullWidth={true}>
                <DialogTitle>
                    <Typography variant="h5" className={classes.title}>
                        Show Info
                    </Typography>
                </DialogTitle>
                <Divider light/>
                <DialogContent >
                <Accordion expanded={showShow} onClick={() => setShowShow(!showShow)}>
                    <AccordionSummary>
                        <Typography variant="h4">
                            General Show Info
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    Created By
                                </Typography>
                                <Typography variant="body2">
                                    {show.createdByUser.id}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    Experience
                                </Typography>
                                <Typography variant="body2">
                                    {show.experience.shortName}
                                </Typography>
                            </Grid>
                            
                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    Host
                                </Typography>
                                <Typography variant="body2">
                                    {show.host.hostName}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    Status
                                </Typography>
                                <Typography variant="body2">
                                    {show.status}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    Preshow Sent
                                </Typography>
                                <Typography variant="body2">
                                    {show.preshowSent ? "yes" : "no"}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    Room Code
                                </Typography>
                                <Typography variant="body2">
                                    {show.roomCode}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    Show Time
                                </Typography>
                                <Typography variant="body2">
                                    {show.showtime}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    highlightsLink
                                </Typography>
                                <Typography variant="body2">
                                    {show.highlightsLink}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" className={classes.bold}>
                                    Price
                                </Typography>
                                <Typography variant="body2">
                                    ${show.price ? show.price : show.experience.defaultPrice / 100}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" className={classes.bold}>
                                    Created at
                                </Typography>
                                <Typography variant="body2">
                                    {show.createdAt}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" className={classes.bold}>
                                    Show Id
                                </Typography>
                                <Typography variant="body2">
                                    {show.id}
                                </Typography>
                            </Grid>
                            {show.recurringShowID && 
                                <Grid item xs={6}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Recurring Show Id
                                    </Typography>
                                    <Typography variant="body2">
                                        {show.recurringShowID}
                                    </Typography>
                                </Grid>
                            }
                            {show.privateShowID && privateShow && 
                                <Grid item xs={6}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Private Show Link
                                    </Typography>
                                    <Typography variant="body2">
                                        <Link href={`${privateShowBaseURL}/${privateShow.id}`}> 
                                            {privateShow.name}
                                        </Link>
                                    </Typography>
                                    <Typography variant="body1" className={classes.bold}>
                                        Private Show description
                                    </Typography>
                                    <Typography variant="body2">
                                        {privateShow.description}
                                    </Typography>
                                </Grid>
                            }
                        </Grid>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={showOrders} onClick={() => setShowOrders(!showOrders)}>
                    <AccordionSummary>
                        <Typography variant="h4">
                            Orders
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.arrayGrid}>
                        {show.orders.items.map((order, index) => (
                            <Grid key={order.id} container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="h5">
                                        Order {index + 1}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Created at
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.createdAt}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Guest Name
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.guest.firstName} {order.guest.lastName}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Guest Email
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.guest.email}
                                    </Typography>
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Receipt URL
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.receiptUrl}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} zeroMinWidth>
                                    <Typography variant="body1" className={classes.bold}>
                                        squareOrderID
                                    </Typography>
                                    <Typography variant="body2" noWrap>
                                        {order.squareOrderID}
                                    </Typography>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Total Amount
                                    </Typography>
                                    <Typography variant="body2">
                                        ${order.totalAmount / 100}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Total Tickets Purchased
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.totalTicketsPurchased}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Status
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.status}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Order ID
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.id}
                                    </Typography>
                                </Grid>
                                {order.coupon && 
                                    <Grid item xs={6}>
                                        <Typography variant="body1" className={classes.bold}>
                                            Coupon Used:
                                        </Typography>
                                        <Typography variant="body2">
                                            {order.coupon}
                                        </Typography>
                                    </Grid>
                                }
                                
                            </Grid>
                        ))
                    }
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={showTickets} onClick={() => setShowTickets(!showTickets)}>
                    <AccordionSummary>
                        <Typography variant="h4">
                            Tickets
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.arrayGrid}>
                        {show?.tickets?.items.map((ticket, index) => (
                            <Grid key={ticket.id} container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="h5">
                                        Ticket {index + 1}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Created at
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.createdAt}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Guest Name
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.guest.firstName} {ticket.guest.lastName}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Guest Email
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.guest.email}
                                    </Typography>
                                </Grid>
                                
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Client Time Zone
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.clientTimezone}
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} zeroMinWidth>
                                    <Typography variant="body1" className={classes.bold}>
                                        How did you hear about AL
                                    </Typography>
                                    <Typography variant="body2" noWrap>
                                        {ticket.howDidYouHearAboutAL}
                                    </Typography>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        How much VR Experience
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.howMuchVRExperience}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Platform
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.platform}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Status
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.status}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Ticket Code
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.ticketCode}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Additional Note
                                    </Typography>
                                    <Typography variant="body2">
                                        {ticket.additionalNote}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))
                    }
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={showReviews} onClick={() => setShowReviews(!showReviews)}>
                    <AccordionSummary>
                        <Typography variant="h4">
                            Reviews
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.arrayGrid}>
                        {show.reviews.items.map((review, index) => (
                            <Grid key={review.id} container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant="h5">
                                        Review {index + 1}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Created at
                                    </Typography>
                                    <Typography variant="body2">
                                        {review.createdAt}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Rating
                                    </Typography>
                                    <Typography variant="body2">
                                        {review.rating}
                                    </Typography>
                                </Grid>
                                {review.tipAmount > 0 &&
                                <Grid item xs={2}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Tip Amount
                                    </Typography>
                                    <Typography variant="body2">
                                        ${(review.tipAmount / 100).toFixed(2)}
                                    </Typography>
                                </Grid>
                                }
                                {review.commentForHost &&
                                <Grid item xs={12}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Comment For Host
                                    </Typography>
                                    <Typography variant="body2">
                                        {review.commentForHost}
                                    </Typography>
                                </Grid>
                                }
                                {review.commentForPrivate &&
                                <Grid item xs={12}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Comment for Private
                                    </Typography>
                                    <Typography variant="body2">
                                        {review.commentForPrivate}
                                    </Typography>
                                </Grid>
                                }
                                {review.commentForPublic &&
                                <Grid item xs={12}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Comment for Public
                                    </Typography>
                                    <Typography variant="body2">
                                        {review.commentForPublic}
                                    </Typography>
                                </Grid>
                                }
                                {review.receiptUrl &&
                                <Grid item xs={12}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Receipt URL
                                    </Typography>
                                    <Typography variant="body2">
                                        {review.receiptUrl}
                                    </Typography>
                                </Grid>
                                }
                                {review.squareOrderID &&

                                <Grid item xs={12} zeroMinWidth>
                                    <Typography variant="body1" className={classes.bold}>
                                        Square Order ID
                                    </Typography>
                                    <Typography variant="body2" noWrap>
                                        {review.squareOrderID}
                                    </Typography>
                                </Grid>
                                }
                                {review.squarePaymentID &&

                                <Grid item xs={6}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Square Payment ID
                                    </Typography>
                                    <Typography variant="body2">
                                        {review.squarePaymentID}
                                    </Typography>
                                </Grid>
                                }
                                {review.squareRefundID &&

                                <Grid item xs={6}>
                                    <Typography variant="body1" className={classes.bold}>
                                        Square Refund ID
                                    </Typography>
                                    <Typography variant="body2">
                                        {review.squareRefundID}
                                    </Typography>
                                </Grid>
                                }
                                
                            </Grid>
                        ))
                    }
                    </AccordionDetails>
                </Accordion>
                </DialogContent>
                <DialogActions>
                        {
                            <Button color="primary" onClick={()=>setShowConfirmationDialog(true)}>
                                {(show.status === "BOOKED" || show.status === "SHOULD_START") ? <><Block />Cancel</> : <><Delete />Delete</>}
                            </Button>
                        }
                        <Button color="primary" onClick={handleEdit}>
                            {/* TODO: Handle what happens when editing already booked show */}
                            <Edit /> Edit
                        </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showConfirmationDialog} onClose={() => setShowConfirmationDialog(false)}>
                <DialogTitle>
                    <Typography variant="h5" className={classes.title}>
                        Are you sure you want to {show.status === "BOOKED" || show.status === "SHOULD_START" ? "cancel" : "delete"} this show?
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    {
                        show.recurringShowID && show.status === "OPEN" &&
                            <Box display="flex" flexDirection="column">
                                <Typography variant="body1">
                                    This is part of a recurring show.  Please choose which shows you want to delete:
                                </Typography>
                                <Box display="flex" justifyContent="center" m={1}>
                                    <Button color="primary" style={{margin: "0 1em 0 1em"}} variant="contained" onClick={handleAllClicked}>All</Button>
                                    <Button color="primary" style={{margin: "0 1em 0 1em"}} variant="contained" onClick={handleNoneClicked}>None</Button>
                                </Box>
                                <Grid container direction="row" justifyContent="center" alignItems="center">
                                    <Grid container item direction="column" justifyContent="flex-start" alignItems="flex-start" xs={6}>
                                        {
                                            recurringShows
                                                .slice(0, recurringShows.length === 1 
                                                        ? 1 
                                                        : Math.ceil(recurringShows.length / 2))
                                                .map((show, index) => (
                                                        <Grid key={show.displayTime} item xs={12}>
                                                            <FormControlLabel
                                                                control={<Checkbox checked={show.checked} onChange={(event) => handleRecurringChange(index, event)} name={show.show.showtime} />}
                                                                label={show.displayTime}
                                                            />
                                                        </Grid>
                                                    )
                                                )
                                        }
                                    </Grid>
                                    <Grid container item direction="column" justifyContent="center" alignItems="flex-start" xs={6}>
                                        {
                                            recurringShows.length !== 1 && 
                                            recurringShows
                                                .slice(Math.ceil(recurringShows.length / 2))
                                                .map((show, index) => (
                                                    <Grid key={show.displayTime} item xs={12}>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={show.checked} onChange={(event) => handleRecurringChange(index + Math.ceil(recurringShows.length / 2), event)} name={show.show.showtime} />}
                                                            label={show.displayTime}
                                                        />
                                                    </Grid>
                                                ))}
                                    </Grid>
                                </Grid>
                            </Box>
                    }
                </DialogContent>
                <DialogActions>
                    {show.recurringShowID && show.status === "OPEN" 
                        ?
                            <>
                                <Button color="primary" onClick={handleDeleteRecurring}>
                                    <Typography variant="button">
                                        Delete Shows
                                    </Typography>
                                </Button>
                                <Button color="primary" onClick={() => setShowConfirmationDialog(false)}>
                                    <Typography variant="button">
                                        Cancel
                                    </Typography>
                                </Button>
                            </>
                        :
                            <>
                                <Button color="primary" onClick={(show.status === "BOOKED" || show.status === "SHOULD_START") ? handleCancel : handleDelete}>
                                    <Typography variant="button">
                                        Yes
                                    </Typography>
                                </Button>
                                <Button color="primary" onClick={() => setShowConfirmationDialog(false)}>
                                    <Typography variant="button">
                                        No
                                    </Typography>
                                </Button>
                            </>
                    }   
                </DialogActions>
            </Dialog>
    </>
    }
</>;
}

export default DialogShowAdminInfo;